export const getTilePosition = (ref: React.RefObject<HTMLDivElement>) => {
    const body = document.querySelector('body');
    const offsetTop = ref.current?.offsetTop!;
    const offsetLeft = ref.current?.offsetLeft!;
    const refWidth = ref.current?.clientWidth!;
    const refHeight = ref.current?.clientHeight!;
    const clientWidth = body?.clientWidth!;
    const clientHeight = body?.clientHeight!;

    return {
        originX: -offsetLeft + (clientWidth / 2 - refWidth / 2),
        originY: -offsetTop + (clientHeight / 2 - refHeight / 2),
    };
};
